import { FuseSettingsConfigType } from '@fuse/core/FuseSettings/FuseSettings';

/**
 * The settingsConfig object is a configuration object for the Fuse application's settings.
 */
const settingsConfig: FuseSettingsConfigType = {
	customScrollbars: true,
	direction: 'ltr',
	layout: {
		style: 'layout1',
		config: {
			mode: 'fullwidth',
			containerWidth: 1120,
			navbar: {
				display: true,
				style: 'style-1',
				folded: false,
				position: 'left',
				open: true
			},
			toolbar: {
				display: true,
				style: 'fixed'
			},
			footer: {
				display: false,
				style: 'static'
			},
			leftSidePanel: {
				display: true
			},
			rightSidePanel: {
				display: true
			}
		}
	},
	theme: {
		main: {
			palette: {
				mode: 'light',
				text: {
					primary: 'rgb(17, 24, 39)',
					secondary: 'rgb(107, 114, 128)',
					disabled: 'rgb(149, 156, 169)'
				},
				common: {
					black: 'rgb(17, 24, 39)',
					white: 'rgb(255, 255, 255)'
				},
				primary: {
					light: '#439889',
					main: '#00695C',
					dark: '#003D33',
					contrastText: 'rgb(255,255,255)'
				},
				secondary: {
					light: '#FFFF74',
					main: '#FFD740',
					dark: '#C8A600',
					contrastText: 'rgb(17, 24, 39)'
				},
				background: {
					paper: '#f2fdfa',
					default: '#dcf2f2'
				},
				error: {
					light: '#F87171',
					main: '#EF4444',
					dark: '#B91C1C',
					contrastText: '#FFFFFF'
				},
				grey: {
					'50': '#F9FAFB',
					'100': '#F3F4F6',
					'200': '#E5E7EB',
					'300': '#D1D5DB',
					'400': '#9CA3AF',
					'500': '#6B7280',
					'600': '#4B5563',
					'700': '#374151',
					'800': '#272F3C',
					'900': '#1F232B',
					A100: '#F3F4F6',
					A200: '#E5E7EB',
					A400: '#6B7280',
					A700: '#374151'
				},
				success: {
					main: '#22C55E',
					light: '#4ADE80',
					dark: '#15803D',
					contrastText: '#1F232B'
				},
				info: {
					main: '#3B82F6',
					light: '#60A5FA',
					dark: '#1D4ED8',
					contrastText: '#FFFFFF'
				},
				warning: {
					main: '#F59E0B',
					light: '#FBBF24',
					dark: '#B45309',
					contrastText: '#1F232B'
				},
				divider: '#b3c4c3',
				action: {
					active: '#4B5563',
					hover: '#E5E7EB',
					selected: '#D1D5DB',
					disabled: '#BFC4CC',
					disabledBackground: '#F6F7F8',
					focus: '#D1D5DB'
				}
			}
		},
		navbar: {
			palette: {
				mode: 'dark',
				text: {
					primary: 'rgb(255,255,255)',
					secondary: 'rgb(148, 163, 184)',
					disabled: 'rgb(156, 163, 175)'
				},
				common: {
					black: 'rgb(17, 24, 39)',
					white: 'rgb(255, 255, 255)'
				},
				primary: {
					light: '#439889',
					main: '#00695C',
					dark: '#003D33',
					contrastText: 'rgb(255,255,255)'
				},
				secondary: {
					light: '#FFFF74',
					main: '#FFD740',
					dark: '#C8A600',
					contrastText: 'rgb(17, 24, 39)'
				},
				background: {
					paper: '#00544a',
					default: '#004D40'
				},
				error: {
					light: '#F87171',
					main: '#EF4444',
					dark: '#B91C1C',
					contrastText: '#FFFFFF'
				},
				grey: {
					'50': '#F9FAFB',
					'100': '#F3F4F6',
					'200': '#E5E7EB',
					'300': '#D1D5DB',
					'400': '#9CA3AF',
					'500': '#6B7280',
					'600': '#4B5563',
					'700': '#374151',
					'800': '#272F3C',
					'900': '#1F232B',
					A100: '#F3F4F6',
					A200: '#E5E7EB',
					A400: '#6B7280',
					A700: '#374151'
				},
				success: {
					main: '#22C55E',
					light: '#4ADE80',
					dark: '#15803D',
					contrastText: '#1F232B'
				},
				info: {
					main: '#3B82F6',
					light: '#60A5FA',
					dark: '#1D4ED8',
					contrastText: '#FFFFFF'
				},
				warning: {
					main: '#F59E0B',
					light: '#FBBF24',
					dark: '#B45309',
					contrastText: '#1F232B'
				},
				divider: '#2d6360',
				action: {
					active: '#4B5563',
					hover: '#E5E7EB',
					selected: '#D1D5DB',
					disabled: '#BFC4CC',
					disabledBackground: '#F6F7F8',
					focus: '#D1D5DB'
				}
			}
		},
		toolbar: {
			palette: {
				mode: 'light',
				text: {
					primary: 'rgb(17, 24, 39)',
					secondary: 'rgb(107, 114, 128)',
					disabled: 'rgb(149, 156, 169)'
				},
				common: {
					black: 'rgb(17, 24, 39)',
					white: 'rgb(255, 255, 255)'
				},
				primary: {
					light: '#439889',
					main: '#00695C',
					dark: '#003D33',
					contrastText: 'rgb(255,255,255)'
				},
				secondary: {
					light: '#FFFF74',
					main: '#FFD740',
					dark: '#C8A600',
					contrastText: 'rgb(17, 24, 39)'
				},
				background: {
					paper: '#f2fdfa',
					default: '#dcf2f2'
				},
				error: {
					light: '#F87171',
					main: '#EF4444',
					dark: '#B91C1C',
					contrastText: '#FFFFFF'
				},
				grey: {
					'50': '#F9FAFB',
					'100': '#F3F4F6',
					'200': '#E5E7EB',
					'300': '#D1D5DB',
					'400': '#9CA3AF',
					'500': '#6B7280',
					'600': '#4B5563',
					'700': '#374151',
					'800': '#272F3C',
					'900': '#1F232B',
					A100: '#F3F4F6',
					A200: '#E5E7EB',
					A400: '#6B7280',
					A700: '#374151'
				},
				success: {
					main: '#22C55E',
					light: '#4ADE80',
					dark: '#15803D',
					contrastText: '#1F232B'
				},
				info: {
					main: '#3B82F6',
					light: '#60A5FA',
					dark: '#1D4ED8',
					contrastText: '#FFFFFF'
				},
				warning: {
					main: '#F59E0B',
					light: '#FBBF24',
					dark: '#B45309',
					contrastText: '#1F232B'
				},
				divider: '#b3c4c3',
				action: {
					active: '#4B5563',
					hover: '#E5E7EB',
					selected: '#D1D5DB',
					disabled: '#BFC4CC',
					disabledBackground: '#F6F7F8',
					focus: '#D1D5DB'
				}
			}
		},
		footer: {
			palette: {
				mode: 'dark',
				text: {
					primary: 'rgb(255,255,255)',
					secondary: 'rgb(148, 163, 184)',
					disabled: 'rgb(156, 163, 175)'
				},
				common: {
					black: 'rgb(17, 24, 39)',
					white: 'rgb(255, 255, 255)'
				},
				primary: {
					light: '#439889',
					main: '#00695C',
					dark: '#003D33',
					contrastText: 'rgb(255,255,255)'
				},
				secondary: {
					light: '#FFFF74',
					main: '#FFD740',
					dark: '#C8A600',
					contrastText: 'rgb(17, 24, 39)'
				},
				background: {
					paper: '#00544a',
					default: '#004D40'
				},
				error: {
					light: '#F87171',
					main: '#EF4444',
					dark: '#B91C1C',
					contrastText: '#FFFFFF'
				},
				grey: {
					'50': '#F9FAFB',
					'100': '#F3F4F6',
					'200': '#E5E7EB',
					'300': '#D1D5DB',
					'400': '#9CA3AF',
					'500': '#6B7280',
					'600': '#4B5563',
					'700': '#374151',
					'800': '#272F3C',
					'900': '#1F232B',
					A100: '#F3F4F6',
					A200: '#E5E7EB',
					A400: '#6B7280',
					A700: '#374151'
				},
				success: {
					main: '#22C55E',
					light: '#4ADE80',
					dark: '#15803D',
					contrastText: '#1F232B'
				},
				info: {
					main: '#3B82F6',
					light: '#60A5FA',
					dark: '#1D4ED8',
					contrastText: '#FFFFFF'
				},
				warning: {
					main: '#F59E0B',
					light: '#FBBF24',
					dark: '#B45309',
					contrastText: '#1F232B'
				},
				divider: '#2d6360',
				action: {
					active: '#4B5563',
					hover: '#E5E7EB',
					selected: '#D1D5DB',
					disabled: '#BFC4CC',
					disabledBackground: '#F6F7F8',
					focus: '#D1D5DB'
				}
			}
		}
	},
	defaultAuth: [
		'Admin',
		'Marketing',
		'HR',
		'RentalOperator',
		'RentalManager',
		'AreaOperator',
		'AreaManager',
		'Manager',
		'Employee',
		'Partner',
		'admin',
		'user',
		'User'
	],
	loginRedirectUrl: '/'
};

export default settingsConfig;
